import { render } from "./UserDetailMore.vue?vue&type=template&id=7d276f39&scoped=true"
import script from "./UserDetailMore.vue?vue&type=script&lang=js"
export * from "./UserDetailMore.vue?vue&type=script&lang=js"

import "./UserDetailMore.vue?vue&type=style&index=0&id=7d276f39&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d276f39"]])

export default __exports__